// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rbc-calendar{ margin-top: 0px; }
.agenda .nueva-cita{ top:250px; }

.agenda-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1rem 0;
  }
  
  .agenda .modal, .modal-cita {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5000;
  }
  
  .agenda .modal-content, .modal-cita .modal-content {
    background: white;
    padding: 2rem;
    border-radius: 10px;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .agenda .modal-content h3, .modal-cita .modal-content h3{ text-align: center; }
  .agenda .modal input, .modal-cita .modal-content input{border-bottom: 1px solid black;}

  .agenda .modal textarea, .modal-cita .modal-content textarea{
    border: 1px solid black;
    border-radius: 8px;
    padding: 5px 10px;
  }

  .agenda .modal .botones, .modal-cita .modal-content .botones{ justify-content: flex-end; }
  .agenda .modal .boton, .modal-cita .modal-content .boton{ padding: 5px 15px; }

.custom-toolbar {
    flex-wrap: wrap;
    align-items: flex-start;
    margin-bottom: 20px;
}

.custom-toolbar .fecha{
    margin: 0 auto;
    align-items: center;
}

.custom-toolbar .fecha .rbc-toolbar-label{ text-align: center; }

.custom-toolbar .fecha .actual{
    background-color: transparent;
    border: none;
}

.custom-toolbar .fecha .actual:hover{
    color: black;
    text-decoration: underline;
}

.custom-toolbar .fecha .desplazar{ background-color: transparent; }
.custom-toolbar .fecha .desplazar:hover{ color: #007932; }


.custom-toolbar .view-buttons button {
    background: none;
    border: none;
    border-right: 2px solid #ccc;
    padding: 0.3rem 0.6rem;
    cursor: pointer;
}

.custom-toolbar .view-buttons button:hover { 
    text-decoration: underline; 
    color: black;
}

.custom-toolbar .view-buttons .rbc-active { color: #007932; }

.rbc-agenda-event-cell div div{font-size: 16px!important;}

.rbc-event{ background-color: #007932; }

.rbc-event div div{ 
    color: white!important; 
    font-size: 14px!important; 
}

.rbc-event.rbc-selected, .rbc-day-slot .rbc-selected.rbc-background-event {
  background-color: #007932;
}

.rbc-event-content strong {
  display: block;         /* Hace que el <strong> ocupe toda la línea */
  white-space: normal;    /* Permite saltos de línea */
  word-break: break-word; /* Rompe palabras largas si es necesario */
  line-height: 1.1;
}

.sugerencias-dni li{ 
  list-style: none;
  margin-left: 5px;
}

.sugerencias-dni li:hover{ 
  list-style: none;
  cursor: pointer;
  background-color: #00793262;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/css/Agenda.css"],"names":[],"mappings":"AAAA,eAAe,eAAe,EAAE;AAChC,qBAAqB,SAAS,EAAE;;AAEhC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,0DAA0D,kBAAkB,EAAE;EAC9E,uDAAuD,8BAA8B,CAAC;;EAEtF;IACE,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,8DAA8D,yBAAyB,EAAE;EACzF,0DAA0D,iBAAiB,EAAE;;AAE/E;IACI,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,2CAA2C,kBAAkB,EAAE;;AAE/D;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA,mCAAmC,6BAA6B,EAAE;AAClE,yCAAyC,cAAc,EAAE;;;AAGzD;IACI,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;AAChB;;AAEA,4CAA4C,cAAc,EAAE;;AAE5D,+BAA+B,yBAAyB,CAAC;;AAEzD,YAAY,yBAAyB,EAAE;;AAEvC;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc,UAAU,6CAA6C;EACrE,mBAAmB,KAAK,4BAA4B;EACpD,sBAAsB,EAAE,0CAA0C;EAClE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B","sourcesContent":[".rbc-calendar{ margin-top: 0px; }\n.agenda .nueva-cita{ top:250px; }\n\n.agenda-toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 1rem 0;\n  }\n  \n  .agenda .modal, .modal-cita {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.4);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 5000;\n  }\n  \n  .agenda .modal-content, .modal-cita .modal-content {\n    background: white;\n    padding: 2rem;\n    border-radius: 10px;\n    min-width: 300px;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .agenda .modal-content h3, .modal-cita .modal-content h3{ text-align: center; }\n  .agenda .modal input, .modal-cita .modal-content input{border-bottom: 1px solid black;}\n\n  .agenda .modal textarea, .modal-cita .modal-content textarea{\n    border: 1px solid black;\n    border-radius: 8px;\n    padding: 5px 10px;\n  }\n\n  .agenda .modal .botones, .modal-cita .modal-content .botones{ justify-content: flex-end; }\n  .agenda .modal .boton, .modal-cita .modal-content .boton{ padding: 5px 15px; }\n\n.custom-toolbar {\n    flex-wrap: wrap;\n    align-items: flex-start;\n    margin-bottom: 20px;\n}\n\n.custom-toolbar .fecha{\n    margin: 0 auto;\n    align-items: center;\n}\n\n.custom-toolbar .fecha .rbc-toolbar-label{ text-align: center; }\n\n.custom-toolbar .fecha .actual{\n    background-color: transparent;\n    border: none;\n}\n\n.custom-toolbar .fecha .actual:hover{\n    color: black;\n    text-decoration: underline;\n}\n\n.custom-toolbar .fecha .desplazar{ background-color: transparent; }\n.custom-toolbar .fecha .desplazar:hover{ color: #007932; }\n\n\n.custom-toolbar .view-buttons button {\n    background: none;\n    border: none;\n    border-right: 2px solid #ccc;\n    padding: 0.3rem 0.6rem;\n    cursor: pointer;\n}\n\n.custom-toolbar .view-buttons button:hover { \n    text-decoration: underline; \n    color: black;\n}\n\n.custom-toolbar .view-buttons .rbc-active { color: #007932; }\n\n.rbc-agenda-event-cell div div{font-size: 16px!important;}\n\n.rbc-event{ background-color: #007932; }\n\n.rbc-event div div{ \n    color: white!important; \n    font-size: 14px!important; \n}\n\n.rbc-event.rbc-selected, .rbc-day-slot .rbc-selected.rbc-background-event {\n  background-color: #007932;\n}\n\n.rbc-event-content strong {\n  display: block;         /* Hace que el <strong> ocupe toda la línea */\n  white-space: normal;    /* Permite saltos de línea */\n  word-break: break-word; /* Rompe palabras largas si es necesario */\n  line-height: 1.1;\n}\n\n.sugerencias-dni li{ \n  list-style: none;\n  margin-left: 5px;\n}\n\n.sugerencias-dni li:hover{ \n  list-style: none;\n  cursor: pointer;\n  background-color: #00793262;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
